"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.propTypes = exports.defaultProps = exports["default"] = void 0;
var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteral"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _javascriptStyleHelpers = require("@uie/javascript-style-helpers");
var _theme = require("@vds/theme");
var _templateObject;
var propTypes = exports.propTypes = {
  /**
   * @ignore
   */
  focusState: _propTypes["default"].bool,
  /**
   * @ignore
   */
  selected: _propTypes["default"].bool,
  /**
   * @ignore
   */
  inverted: _propTypes["default"].bool,
  /**
   * @ignore
   */
  colorConfig: _propTypes["default"].object
};
var defaultProps = exports.defaultProps = {
  focusState: false,
  selected: false,
  colorConfig: _theme.colors,
  inverted: false
};

/**
 * @ignore
 */
var ColorInput = /*#__PURE__*/_styledComponents["default"].input.withConfig({
  displayName: "ColorInput",
  componentId: "sc-1ault8k-0"
})(_templateObject || (_templateObject = (0, _taggedTemplateLiteral2["default"])(["\n  clip: rect(0 0 0 0);\n  position: absolute;\n  opacity: 0;\n  overflow: hidden;\n  padding: 0;\n  border: 0;\n  white-space: nowrap;\n  ", ";\n  ", ";\n"])), function (_ref) {
  var focusState = _ref.focusState,
    showFocus = _ref.showFocus,
    colorConfig = _ref.colorConfig;
  return !focusState && showFocus && "\n    &:focus + label {\n      .radioSwatch {\n        outline: ".concat((0, _javascriptStyleHelpers.calculateRem)(1), " dashed\n          ").concat(function (_ref2) {
    var colorConfig = _ref2.colorConfig;
    return colorConfig.black;
  }, ";\n        outline-offset: ").concat((0, _javascriptStyleHelpers.calculateRem)(2), ";\n      }\n    }\n  ");
}, function (_ref3) {
  var focusState = _ref3.focusState,
    colorConfig = _ref3.colorConfig,
    showFocus = _ref3.showFocus,
    inverted = _ref3.inverted;
  return focusState && showFocus && "\n    &:focus:not(:hover) + label {\n      .radioSwatch {\n        outline: none;\n        &::after {\n          display: inline-block;\n          border: ".concat((0, _javascriptStyleHelpers.calculateRem)(1), " dashed ").concat(inverted ? colorConfig.white : colorConfig.black, ";\n          border-radius: 50%;\n          content: '';\n          height: calc(100% + ").concat((0, _javascriptStyleHelpers.calculateRem)(4), ");\n          left: 50%; \n          position: absolute;\n          top: 50%;\n          transform: translate(-50%, -50%);\n          width: calc(100% + ").concat((0, _javascriptStyleHelpers.calculateRem)(4), ");\n        }\n      }\n    }\n  ");
});
ColorInput.propTypes = propTypes;
ColorInput.defaultProps = defaultProps;
var _default = exports["default"] = ColorInput;


//////////////////
// WEBPACK FOOTER
// ./~/@vds/inputs/dist/cjs/components/RadioSwatch/ColorInput.js
// module id = 1455
// module chunks = 0